export default __webpack_public_path__ + "static/black-209d0f28dbefad3a4760cd3464175898.png";